import TableComponent from '../../../../components/table/TableComponent';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useOnMount } from '../../../../components/common/Hooks';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDirection, setPage, setSortField } from '../../../../redux/slices/PaginationSlice';
import { deleteEmployee, getEmployeesPage, save } from './EmployeesService';
import { Spinner } from 'react-bootstrap';
import { EmployeeForm } from './EmployeeForm';
import { ConfirmationModal } from '../../../../components/modal/ConfirmationModal';
import { EditButton } from '../../../../components/buttons/EditButton';
import { DeleteButton } from '../../../../components/buttons/DeleteButton';

export const EmployeesPage = () => {

    const { t, i18n } = useTranslation();
    const alert = useAlert();
    const onMount = useOnMount();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const pagination = useSelector((state) => state.pagination);
    const [raeEmployees, setRawEmployees] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [employee, setEmployee] = useState({
        name: '',
        surname: '',
        email: '',
        role: -1,
    });
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const handleCloseModal = () => setIsConfirmOpen(false);

    useEffect(() => {
        if (onMount) {
            init();
        } else {
            loadEmployees();
        }

    }, [pagination.page, pagination.sortByField, pagination.sortingDirection]);

    const init = () => {
        if (pagination.sortByField === 'lastName'
            && pagination.page === 0
            && pagination.sortingDirection === 'ASC') {
            loadEmployees();
        } else {
            dispatch(setSortField('lastName'));
            dispatch(setPage(0));
            dispatch(setDirection('ASC'));
        }
    };

    const loadEmployees = () => {
        let request = {
            page: pagination.page,
            size: pagination.size,
            ascDesc: pagination.sortingDirection,
            sortField: pagination.sortByField,
            lang: i18n.language.toUpperCase(),
        };
        setLoading(true);
        getEmployeesPage(request)
            .then((response) => mapResponse(response))
            .catch(() => alert.error(t('alert:loadingError')))
            .finally(() => setLoading(false));
    };

    const mapResponse = (response) => {
        setRawEmployees(response.data.content);
        let totalElements = response.data.totalElements;
        let content = response.data.content.map(employee => {
            return { ...employee, role: t('common:roles.' + employee.role) };
        });
        setEmployees({ totalElements: totalElements, content: content });
    };

    const handleSubmit = (values, employeeId) => {
        let employee = { ...values, id: employeeId };
        save(employee)
            .then(() => {
                alert.success(t('alert:saveSuccess'));
                loadEmployees();
            })
            .catch((error) => handleError(error));
    };

    const handleError = (error) => {
        let status = error.response.status;
        if (status === 403) {
            return alert.error(t('alert:maxEmployees'));
        } else {
            return alert.error(t('alert:saveError'));
        }
    };

    const handleCancel = () => {
        setEmployee({
            name: '',
            lastName: '',
            email: '',
            role: -1,
        });
    };

    const editRecord = (employee) => {
        setEmployee({
            id: employee.id,
            lastName: employee.lastName,
            name: employee.name,
            email: employee.email,
            role: raeEmployees.find(it => it.id === employee.id).role,
        });
        document.getElementById('createButton').click();
    };

    const openConfirmation = (employee) => {
        setItemToDelete(employee);
        setIsConfirmOpen(true);
    };

    const deleteRecord = () => {
        deleteEmployee(itemToDelete.id)
            .then(() => {
                alert.success(t('alert:deleteSuccess'));
                loadEmployees();
            })
            .catch(() => alert.error(t('alert:deleteError')));
        handleCloseModal();
    };

    const getButtons = () => {
        return [
            { element: <EditButton onClick={editRecord} /> },
            { element: <DeleteButton onClick={openConfirmation} /> }
        ];
    };

    return (
        <div>
            <EmployeeForm onClick={handleSubmit}
                          onCancel={handleCancel}
                          editingEmployee={employee}>
            </EmployeeForm>
            <ConfirmationModal
                message={t('employee:deleteConfirm') + (itemToDelete != null
                    ? itemToDelete.name + ' ' + itemToDelete.lastName
                    : '') + '?'}
                isShowing={isConfirmOpen}
                onConfirm={deleteRecord}
                onClose={handleCloseModal}>
            </ConfirmationModal>
            {loading ? (
                <Spinner animation='border' className='container' />
            ) : (<TableComponent
                model={{
                    lastName: '',
                    name: '',
                    email: '',
                    role: '',
                }}
                translationsGroup='employee:'
                columnsNames={[
                    'lastName',
                    'name',
                    'email',
                    'role',
                ]}
                totalElements={employees.totalElements}
                contents={employees.content}
                buttons={getButtons()}>
            </TableComponent>)}
        </div>
    );
};